var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSiniWithText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.559,
    height: 19.559,
    fill: "none",
    viewBox: "0 0 19.559 19.559",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 19.559,
    height: 19.559,
    style: {
      fillRule: "evenodd",
      fill: "#fff",
      paintOrder: "stroke markers fill",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 100,
      strokeWidth: 1.5163
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_2870",
    x1: 2.8665,
    x2: 8.1805,
    y1: 1.9416,
    y2: 9.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7BFD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A5ED",
    offset: 0.46404
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDC44",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.817,
    height: 13.057,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.3711 .34376)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5841 1.5841c2.1121-2.1121 5.5364-2.1121 7.6486 0s2.1122 5.5366 0 7.6487l-3.8243 3.8242-3.8243-3.8242c-2.1121-2.1121-2.1121-5.5366 0-7.6487z",
    fill: "url(#paint0_linear_35_2870)",
    style: {
      fill: "url(#paint0_linear_35_2870)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.4083 7.3868c1.0925 0 1.9781-0.8856 1.9781-1.9781s-0.88566-1.9781-1.9781-1.9781-1.9781 0.8856-1.9781 1.9781 0.88565 1.9781 1.9781 1.9781z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#2a6fe4",
      strokeWidth: "1.3911px",
      stroke: "#000"
    },
    "aria-label": "SINI AI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.119 18.843q-0.31401 0-0.58655-0.07702t-0.48583-0.21329q-0.21329-0.14219-0.35548-0.31401-0.13627-0.17182-0.17774-0.36141l0.79391-0.23699q0.077021 0.20144 0.27254 0.34956 0.19552 0.14219 0.49175 0.14812 0.31401 0.0059 0.50952-0.13627 0.20144-0.14219 0.20144-0.36733 0-0.19552-0.15997-0.32586-0.15404-0.13627-0.42658-0.20736l-0.53915-0.14219q-0.30216-0.07702-0.53322-0.23106-0.23106-0.15997-0.36141-0.39103t-0.13034-0.53915q0-0.58654 0.38511-0.9124 0.39103-0.33178 1.102-0.33178 0.39695 0 0.69319 0.11849 0.30216 0.11257 0.5036 0.32586 0.20144 0.21329 0.30808 0.5036l-0.78799 0.24291q-0.071096-0.20144-0.26069-0.34363-0.18959-0.14219-0.4799-0.14219-0.29624 0-0.46805 0.13627-0.16589 0.13627-0.16589 0.3851 0 0.19552 0.13034 0.30808 0.13627 0.11257 0.36733 0.17182l0.54507 0.13627q0.53322 0.13034 0.82946 0.46805 0.29623 0.33771 0.29623 0.75244 0 0.36733-0.17774 0.64579-0.17774 0.27254-0.51545 0.42658-0.33771 0.15404-0.81761 0.15404z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.085034 18.771v-4.1473h0.81168v4.1473z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.7973 18.771v-4.1473h0.84723l2.0262 2.7846v-2.7846h0.80576v4.1473h-0.80576l-2.0618-2.8379v2.8379z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.3771 18.771v-4.1473h0.81168v4.1473z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.373 18.771-1.5878-4.1473h0.81168l1.6352 4.1473zm-3.2764 0 1.6352-4.1473h0.81168l-1.5878 4.1473zm0.77021-0.9124v-0.71689h2.6009v0.71689z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.73 18.771v-4.1473h0.81168v4.1473z",
    style: {
      stroke: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiniWithText);
export default __webpack_public_path__ + "static/media/icon_sini_with_text.f08e209a068e9224c3d54b85b50c36b9.svg";
export { ForwardRef as ReactComponent };